/* lm-form-validate — replaces the browser's native validation bubbles with custom, on-brand inline
   messages on the LM contact + newsletter forms. Keeps the required/type=email attributes (for the
   Constraint Validation API) but suppresses the native UI via novalidate. Validates on submit, then
   clears each field's error as the user fixes it. Valid forms submit normally (Shopify {% form %}). */
(function () {
  'use strict';

  function messageFor(c) {
    if (c.type === 'email') {
      if (c.validity.valueMissing) return 'Please enter your email address.';
      if (c.validity.typeMismatch) return 'Please enter a valid email address.';
    }
    if (c.validity.valueMissing) {
      var label = (c.getAttribute('aria-label') || 'this field').toLowerCase();
      return 'Please enter your ' + label + '.';
    }
    if (c.validity.tooLong) return 'That message is a little too long.';
    return 'Please check this field.';
  }

  function errorEl(c) {
    var el = c.nextElementSibling;
    if (!el || !el.classList || !el.classList.contains('lm-field-error')) {
      el = document.createElement('span');
      el.className = 'lm-field-error';
      el.setAttribute('aria-live', 'polite');
      c.insertAdjacentElement('afterend', el);
    }
    return el;
  }
  function showError(c) {
    c.classList.add('is-error');
    c.setAttribute('aria-invalid', 'true');
    var el = errorEl(c);
    el.textContent = messageFor(c);
    el.removeAttribute('hidden');
  }
  function clearError(c) {
    c.classList.remove('is-error');
    c.removeAttribute('aria-invalid');
    var el = c.nextElementSibling;
    if (el && el.classList && el.classList.contains('lm-field-error')) el.setAttribute('hidden', '');
  }

  function init(form) {
    form.setAttribute('novalidate', '');
    var controls = Array.prototype.slice.call(
      form.querySelectorAll('input[required], textarea[required], input[type="email"]')
    );

    form.addEventListener('submit', function (e) {
      var firstInvalid = null;
      controls.forEach(function (c) {
        if (c.checkValidity()) { clearError(c); }
        else { showError(c); if (!firstInvalid) firstInvalid = c; }
      });
      if (firstInvalid) { e.preventDefault(); firstInvalid.focus(); }
    });

    controls.forEach(function (c) {
      var revalidate = function () { if (c.classList.contains('is-error') && c.checkValidity()) clearError(c); };
      c.addEventListener('input', revalidate);
      c.addEventListener('blur', function () { if (c.value && !c.checkValidity()) showError(c); });
    });
  }

  function boot() {
    document.querySelectorAll('form.lm-contact-form').forEach(init);
  }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();
